// src/pages/IAOperations/Columns.js

export const Columns = (
  navigate
) => {
  // Ir a la vista de progreso específica (misma lógica que tenías)
  const handleViewProgress = (row) => {
    if (row.model === "ChatConversation") {
      return;
    }

    if (row.model === "TrailerTruck") {
      navigate(`/ia-trk/${row.id}`);
    } else if (row.id) {
      navigate(`/ia-loads/${row.id}`);
    }
  };

  return [
    {
      id: "token",
      name: "TOKEN",
      selector: (row) => `${row.token}`,
      minWidth: "160px",
      cell: (row) => (
        <span className="px-2 py-1 rounded-lg bg-cs-primary-soft text-[10px] font-medium text-cs-primary-dark">
          {row.token}
        </span>
      ),
    },
    {
      id: "detail",
      name: "DETAIL",
      minWidth: "260px",
      cell: (row) => (
        <div className="flex flex-col">
          <span className="text-xs font-medium text-cs-dark">
            {row.detail || "-"}
          </span>
          {row.detailModel && (
            <span className="text-[10px] text-cs-muted">
              {row.detailModel}
            </span>
          )}
        </div>
      ),
    },
    {
      id: "status",
      name: "STATUS",
      selector: (row) => `${row.status?.name}`,
      minWidth: "130px",
      cell: (row) => {
        const label = row.status?.name || "Unknown";
        const normalized = label.toLowerCase();

        let classes =
          "bg-cs-bg-alt text-cs-muted border border-cs-border/60";
        if (normalized.includes("running") || normalized.includes("progress")) {
          classes = "bg-cs-primary-soft text-cs-primary-dark";
        } else if (normalized.includes("completed") || normalized.includes("done")) {
          classes = "bg-cs-success/10 text-cs-success";
        } else if (normalized.includes("error") || normalized.includes("fail")) {
          classes = "bg-cs-danger/10 text-cs-danger";
        }

        return (
          <span
            className={`
              inline-flex items-center px-2 py-1 rounded-full
              text-[10px] font-medium
              ${classes}
            `}
          >
            <span className="w-1.5 h-1.5 rounded-full bg-current mr-1.5" />
            {label}
          </span>
        );
      },
    },
    {
      id: "date",
      name: "DATE",
      selector: (row) => `${row.created_at}`,
      minWidth: "150px",
      cell: (row) => (
        <span className="text-[10px] text-cs-muted">
          {row.created_at || "-"}
        </span>
      ),
    },
    {
      id: "actions",
      name: "",
      button: true,
      minWidth: "90px",
      cell: (row) => (
        <div className="flex items-center space-x-2 justify-end">
          {/* Ver progreso (misma funcionalidad) */}
          {row.model !== "ChatConversation" && (
            <button
              onClick={() => handleViewProgress(row)}
              type="button"
              className="
                p-1.5 rounded-lg
                hover:bg-cs-primary-soft
                text-cs-muted hover:text-cs-primary
                transition-colors
              "
              title="View details"
            >
              <span className="material-symbols-outlined text-[18px]">
                visibility
              </span>
            </button>
          )}

          {/*
          // Si luego reactivas delete:
          <button
            onClick={() =>
              setModalConfirm({
                ...modalConfirm,
                show: true,
                id: row.id,
              })
            }
            disabled={!row.can?.delete}
            className={`
              p-1.5 rounded-lg transition-colors
              ${
                row.can?.delete
                  ? "hover:bg-cs-primary-soft text-cs-danger hover:text-cs-danger"
                  : "opacity-40 cursor-not-allowed text-cs-muted"
              }
            `}
            title="Delete"
          >
            <span className="material-symbols-outlined text-[18px]">
              delete
            </span>
          </button>
          */}
        </div>
      ),
    },
  ];
};
